export default __webpack_public_path__ + "static/media/element_21.495e7e94.webp";